<template>
    <div>
        <button class="button cursor-pointer" @click.prevent="upgradeToken" :disabled="upgradingToken || !eligibleForUpgrade">
                <span v-if="loadingTokenBalance">
                     <spinner-component :color="'text-light'"></spinner-component>
                    Loading token balance...
                </span>
            <span v-else-if="upgradingToken">
                    <spinner-component :color="'text-light'"></spinner-component>
                    Upgrading token...
                </span>
            <span v-else>Upgrade {{ token.name }} To XLS20</span>
        </button>

        <sweet-modal overlay-theme="dark" ref="upgradeTokenModal" :blocking="true">
            <h4 class="py-2" slot="title">Upgrade Token</h4>
            <div class="text-center">
                <p class="mb-5">
                    A notification has been sent to your mobile application. Open the Xumm
                    Application on your device to complete the transaction.
                </p>

                <template v-if="payloadData">
                    <p class="mb-5">or scan this code in your XUMM app</p>

                    <img :src="payloadData.qrCode" alt="Qr Code">
                </template>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import SpinnerComponent from "./SpinnerComponent";

export default {
    props: {
        token: Object,
        channel: String
    },

    components: {
        SpinnerComponent,
        SweetModal,
        SweetModalTab
    },

    data() {
        return {
            upgradingToken: false,
            loadingTokenBalance: false,
            tokenBalance: 0,
            tokenNftBalance: 0,
            payloadData: null
        }
    },

    computed: {
        eligibleForUpgrade() {
            return this.tokenBalance > 0 && this.tokenNftBalance > 0;
        }
    },

    created() {
        this.getTokenCurrencyBalance()
    },

    methods: {
        getTokenCurrencyBalance() {
            this.loadingTokenBalance = true
            axios.post('/get-token-balance', {wtfNfToken: this.token}).then((response) => {
                this.tokenBalance = response.data.tokenBalance
                this.tokenNftBalance = response.data.nftTokenBalance
                this.loadingTokenBalance = false
            }).catch((error) => {
                this.loadingTokenBalance = false
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
            })
        },

        upgradeToken() {
            this.upgradingToken = true
            axios.post('/upgrade-token', {tokenDetails: this.token}).then((response) => {
                this.payloadData = response.data
                this.$refs.upgradeTokenModal.open()
                window.Echo.channel(this.channel).listen('XummMessageReceived', (event) => {
                    if(event.message.signed) {
                        this.upgradingToken = false
                        this.getTokenCurrencyBalance()
                        Toast.fire({
                            icon: event.message.status,
                            title: event.message.code
                        })
                        this.$refs.upgradeTokenModal.close()
                    } else {
                        this.upgradingToken = false
                        Toast.fire({
                            icon: event.message.status,
                            title: event.message.code
                        })
                        this.$refs.upgradeTokenModal.close()
                    }
                });
            })
            .catch((error) => {
                this.upgradingToken = false
                Swal.fire({
                    icon: 'error',
                    text: error.response.data.message
                })
            })
        },
    }
}
</script>

<style lang="scss">
button:disabled,
button[disabled]{
    border: unset;
    background-color: #cccccc !important;
    color: #666666;
    cursor: not-allowed;
    pointer-events: none;
}
button {
    outline: none;
    border: none;
    margin-top: 24px;
}
.cursor-pointer {
    cursor: pointer;
}
</style>
